module.exports = __webpack_public_path__ + "static/caidio_logo-5b40a6cee6fdfcc69be7c1bbd3335b7a.png";